<template>
  <div>
    <va-modal
      large
      :title="modalTitle"
      class="modal"
      v-model="showEditorAdt"
      :okText="saveAdtMessage"
      cancelText="Annuler"
      v-on:ok="saveAdt"
      v-on:cancel="closeModal"
    >
      <div class="row row-inside modify-adt">
        <div class="flex md12">
          <div class="row row-inside my-2">
            <div class="flex md4">Année:</div>
            <div class="flex md8">{{ activeAdt.annee }}</div>
          </div>
          <div class="row row-inside my-2">
            <div class="flex md4">Montant:</div>
            <div class="flex md3">
              <va-input
                :disabled="!!activeAdt.idrecu || !!activeAdt.date_paiement_fr"
                v-model="activeAdt.montant_adhesion"
                placeholder="-"
              />
            </div>
            <div class="flex md1 px-2 py-2">€</div>
          </div>
          <div class="row row-inside my-2">
            <div class="flex md4">Nombre d'entreprises:</div>
            <div class="flex md2">{{ activeAdt.nb_entreprise }}</div>
            <div class="flex md4">
              <va-button
                small
                :disabled="!!activeAdt.idrecu || !!activeAdt.date_paiement_fr"
                class="fullwidth"
                :color="activeAdt.updateEntreprises ? 'success' : 'info'"
                outline
                @click="recountEntreprises()"
                >Recalculer</va-button
              >
            </div>
          </div>
          <div class="row row-inside my-2">
            <div class="flex md4">Montant total:</div>
            <div class="flex md8">
              {{ activeAdt.montant_adhesion * activeAdt.nb_entreprise }} €
            </div>
          </div>
          <div class="row row-inside my-2">
            <div class="flex md4">Date de paiement:</div>
            <div class="flex md4">
              <va-date-picker
                :disabled="!!activeAdt.date_recu"
                :config="{ dateFormat: 'd-m-Y' }"
                v-model="activeAdt.date_paiement_fr"
              />
            </div>
          </div>
          <div class="row row-inside my-2">
            <div class="flex md4">Mode de paiement:</div>
            <div class="flex md8">
              <va-select
                :disabled="!activeAdt.date_paiement_fr || !!activeAdt.date_recu"
                label="Mode de paiement"
                v-model="activeAdt.activePaiement"
                textBy="description"
                :options="paiementOptions"
                no-clear
              />
            </div>
          </div>
          <div class="row row-inside mt-4">
            <div class="flex md6">
              <va-button
                small
                :disabled="adtUpdated"
                class="fullwidth"
                :color="activeAdt.date_rappel ? 'success' : 'info'"
                outline
                @click="getAppel()"
                >Appel à cotisation</va-button
              >
            </div>
            <div class="flex md6">
              <va-button
                small
                :disabled="adtUpdated || !!activeAdt.idpaiement_type"
                class="fullwidth"
                :color="!!activeAdt.date_recu ? 'success' : 'info'"
                outline
                @click="downloadAppel()"
                >Reçu</va-button
              >
            </div>
          </div>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import moment from "moment";

import axios from "axios";
import { cloneDeep, isEqual, find } from "lodash";

export default {
  name: "adt-modal",
  props: ["idAdt", "showEditor"],

  data() {
    return {
      showEditorAdt: false,
      activeAdt: {},
      originalAdt: {},
      adtUpdated: false,
      paiementOptions: [
        {
          id: 2,
          description: "Chèque",
        },
        {
          id: 3,
          description: "Virement",
        },
        {
          id: 4,
          description: "Espèces",
        },
      ],
    };
  },
  created() {
    this.initAdt();
  },
  computed: {
    saveAdtMessage: function () {
      return this.adtUpdated ? "Sauvegarder les modifications" : "Fermer";
    },
    modalTitle: function () {
      let text = "Appel de cotisation - ";

      if (this.idsyndicat === "opam") {
        text = text + "OPAM-B";
      } else if (this.idsyndicat === "agromer") {
        text = text + "AGROMER";
      } else if (this.idsyndicat === "scapp") {
        text = text + "SCAPP";
      } else if (this.idsyndicat === "Languedoc-Roussillon") {
        text = text + "Languedoc-Roussillon";
      } else if (this.idsyndicat === "Vendee") {
        text = text + "Vendée";
      } else if (this.idsyndicat === "SDEP") {
        text = text + "S.D.E.P.";
      } else {
        text = "";
      }

      text = text + " - " + this.originalAdt.annee;
      return text;
    },
  },
  watch: {
    activeAdt: {
      deep: true,
      handler() {
        if (!isEqual(this.activeAdt, this.originalAdt)) {
          this.adtUpdated = true;
        } else {
          this.adtUpdated = false;
        }
      },
    },

    showEditor(newvalue) {
      if (newvalue === true) {
        this.getAdt();
        this.showEditorAdt = true;
      }
    },
  },
  methods: {
    async getAppel() {
      this.isaction = true;
      try {
        if (!this.idAdt || this.adtUpdated) {
          return;
        }

        let pdfurl = await axios.get("api/adt/appel", {
          params: { idadhesion: this.idAdt },
        });
        this.openNewTab(pdfurl.data);
      } catch (error) {
        console.log(error);
      }
    },
    openNewTab(url) {
      try {
        window.open(url, "_blank");
        this.ok();
      } catch (err) {}
    },
    async recountEntreprises() {
      try {
        let results = await axios.get("/api/adt/nbfirms", {
          params: { idAdt: this.idAdt },
        });

        this.activeAdt.nb_entreprise = results.data.newLength;
        this.activeAdt.updateEntreprises = true;
      } catch (error) {
        res.status(500).send("ko");
      }
    },
    async saveAdt() {
      this.showEditorAdt = true;
      try {
        if (!this.adtUpdated) {
          this.closeModal();
          return;
        }
        // gather what needs to be updated
        let update = {
          updateEntreprises: this.activeAdt.updateEntreprises ? true : null,
          montant_adhesion:
            this.activeAdt.montant_adhesion ===
            this.originalAdt.montant_adhesion
              ? null
              : this.activeAdt.montant_adhesion,
          date_paiement:
            this.activeAdt.date_paiement_fr ===
            this.originalAdt.date_paiement_fr
              ? null
              : moment(this.activeAdt.date_paiement_fr, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                ),
          idpaiement_type: isEqual(
            this.activeAdt.activePaiement,
            this.originalAdt.activePaiement
          )
            ? null
            : this.activeAdt.activePaiement.id,
        };
        let params = {};
        params.idadt = this.activeAdt.idrappel_adhesions_tierce;
        params.update = update;
        let response = await axios.put("/api/adt/adhesion", params);
        this.$emit("updateList");
        this.closeModal();
      } catch (error) {
        console.log(error);
      }
    },
    closeModal() {
      this.showEditorAdt = false;
      this.initAdt();
      this.$emit("close");
    },
    async getAdt() {
      try {
        let results = await axios.get("/api/adt/infos", {
          params: { idAdt: this.idAdt },
        });

        console.log(results.data);
        if (results.data) {
          results.data.activePaiement = {
            id: 1,
            description: "inconnu",
          };
          if (results.data.idpaiement_type) {
            let paiement = find(this.paiementOptions, [
              "id",
              results.data.idpaiement_type,
            ]);
            if (paiement) {
              results.data.activePaiement = paiement;
            }
          }
          results.data.updateEntreprises = false;
          this.adtUpdated = false;
          this.activeAdt = results.data;
          this.originalAdt = cloneDeep(this.activeAdt);
        }
      } catch (error) {}
    },
    initAdt() {
      this.activeAdt = {
        annee: null,
        date_creation: null,
        date_paiement: null,
        date_rappel: null,
        date_recu: null,
        idpaiement_type: null,
        idrappel_adhesions_tierce: null,
        idsyndicat: null,
        listEntreprise: [],
        montant_adhesion: null,
        montant_total: null,
        nb_entreprise: null,
        activePaiement: {
          id: 1,
          description: "inconnu",
        },
        updateEntreprises: false,
      };
    },
  },
};
</script>

<style lang="scss">
.padded-input {
  padding-left: 0.25rem;
}
.modify-etablissement-row {
  top: 0.5em;
}
.modify-adt {
  width: 25vw;
  height: 40vh;
}

.fullwidth {
  width: 95%;
}
</style>
